import {Redis} from "@upstash/redis";

export const redis = new Redis({
    url: process.env.UPSTASH_REDIS_REST_URL || 'https://cunning-mastiff-50268.upstash.io',
    token: process.env.UPSTASH_REDIS_REST_TOKEN || 'AcRcAAIjcDFmMGRlZTA0OTA0MjM0NmIyYjIxMDY2MWE4OWU0NDI5NnAxMA',
})